import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';
import { LanguageSettings } from '@src/suite/common/services/language-settings';

const MAX_SYMBOLS = 50;

@Component({
    selector: 'st-attachment-rename',
    templateUrl: './attachment-rename.html',
    styleUrls: ['./attachment-rename.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-attachment-rename',
    },
})
export class AttachmentRenameComponent implements OnInit {
    attachmentName = new FormControl<string>('');
    public extension: string = '';
    public maxSymbols: number = MAX_SYMBOLS;

    constructor(
        public languageSettings: LanguageSettings,
        public dialogRef: DialogRef<string>,
        @Inject(DIALOG_DATA) public data: { fileName: string }
    ) {}

    ngOnInit() {
        this.extractFileNameParts(this.data.fileName);
    }

    private extractFileNameParts(fileName: string) {
        let name = '';
        if (fileName && fileName.length > 0) {
            const extInd = fileName.lastIndexOf('.');
            if (extInd > -1) {
                this.extension = fileName.substring(extInd);
                this.maxSymbols = MAX_SYMBOLS - this.extension.length;
                if (extInd > this.maxSymbols) {
                    name = fileName.substring(0, this.maxSymbols);
                } else {
                    name = fileName.substring(0, extInd);
                }
            } else {
                this.extension = '';
                this.maxSymbols = MAX_SYMBOLS;
            }
        } else {
            this.extension = '';
            this.maxSymbols = MAX_SYMBOLS;
        }
        this.attachmentName.setValue(name);
    }

    public get disabled(): boolean {
        return !this.attachmentName.value || this.attachmentName.value.trim() === '';
    }

    public get fileName(): string {
        return this.attachmentName.value + this.extension;
    }

    renameAttachment() {
        this.dialogRef.close(this.fileName);
    }

    cancel() {
        this.dialogRef.close();
    }
}
